import axios from 'axios';
import qs from 'qs';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

export const getGroupsService = (total, offset, limit = 50, searchText = '') => axios({
    method: 'get',
    url: `${baseURL}/dws/usergroup?api_key=setup_manager&limit=${limit}&offset=${offset}${total ? `&total=${total}` : ''}&searchByText=${searchText}`,
    headers: {
        'Content-Type': 'application/json',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getGroupByIDService = id => axios({
    method: 'get',
    url: `${baseURL}/dws/usergroup/GroupId/${id}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const deleteGroupService = id => axios({
    method: 'delete',
    url: `${baseURL}/dws/usergroup/groupid/${id}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getMusicOnHoldService = () => axios({
    method: 'get',
    url: `${baseURL}/dws/moh?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const createUserGroupService = userGroup => axios({
    method: 'post',
    url: `${baseURL}/dws/usergroup?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        Description: userGroup.Description,
        ExtraDescription: userGroup.ExtraDescription,
        AddRoles: userGroup.AddRoles,
        Members: userGroup.Members,
        api_key: 'setup_manager'
    })
});

export const updateUserGroupService = (id, userGroup) => axios({
    method: 'put',
    url: `${baseURL}/dws/usergroup/GroupId/${id}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        ...userGroup,
        api_key: 'setup_manager'
    })
});

export const uploadUserGroupPhoto = (file, id) => {
    const form = new FormData();

    form.append('file', file);
    form.append('Id', id);
    form.append('filetype', 'userGroup_pic');
    form.append('api_key', 'setup_manager');

    return axios({
        method: 'post',
        url: `${baseURL}/dws/upload`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'x-adminapi-token': localStorage.getItem('token')
        },
        data: form
    });
};
